import { useBrandColorContext } from "@/contexts";
import { TournatedLogo, TournatedWhiteLogo } from "@/ui";

export type ProjectLogoProps = {
  className?: string;
  width?: number;
  height?: number;
  variant?: "default" | "light";
};

export const ProjectLogo = ({
  className,
  width = 120,
  height = 20,
  variant = "default",
}: ProjectLogoProps) => {
  const { title, lightLogo, darkLogo } = useBrandColorContext();
  const src = variant === "light" ? darkLogo || lightLogo : lightLogo || darkLogo;

  if (!src) {
    const Logo = variant === "light" ? TournatedWhiteLogo : TournatedLogo;
    return <Logo className={className} width={width} height={height} />;
  }

  return <img className={className} src={src} width={width} height={height} alt={title} />;
};
